<template>
  <CustomDialog v-model="dialog" ref="customDialog" hideFooter hideHeader>
    <v-stepper v-model="step" class="transparent elevation-0 pa-0">
      <!-- Etapa 1 -->
      <v-stepper-content step="1" class="pa-0">
        <div>
          <div class="text-h5 font-weight-bold mb-2">
            👋 Boas-vindas à {{ $settings.profile?.name }}!
          </div>

          <p>Aqui você transforma diversão em prêmios! 🎉</p>

          <p>
            Complete <strong>desafios diários</strong> e ganhe
            <strong>bilhetes</strong> para participar de
            <strong>sorteios em dinheiro</strong> — tudo de forma
            <strong>100% gratuita</strong>.
          </p>
        </div>

        <div class="d-flex justify-end mt-4">
          <v-btn class="btn" color="primary" @click="step++">Continuar</v-btn>
        </div>
      </v-stepper-content>

      <!-- Etapa 2 -->
      <v-stepper-content step="2" class="pa-0">
        <div>
          <div class="text-h5 font-weight-bold mb-2">🎮 Como jogar</div>

          <p>
            Acesse os jogos na <strong>tela inicial</strong> e participe dos
            desafios diários. Ao vencer, você acumula <strong>bilhetes</strong>.
          </p>

          <p>
            Cada bilhete vale uma chance no
            <strong>sorteio diário de R$ 1.000</strong>. E o melhor: os prêmios
            podem acumular!
          </p>

          <p class="mt-3">Veja abaixo onde começar a jogar:</p>

          <div class="d-flex align-center justify-center mt-4">
            <v-img
              :src="require('@/assets/main/tutorial.png')"
              alt="Exemplo de onde jogar"
              max-width="80%"
              contain
              class="rounded-xl"
            />
          </div>
        </div>

        <div class="d-flex justify-end mt-4">
          <v-btn class="btn" color="primary" @click="step++">Próximo</v-btn>
        </div>
      </v-stepper-content>

      <!-- Etapa 3 -->
      <v-stepper-content step="3" class="pa-0">
        <div>
          <div class="text-h5 font-weight-bold mb-2">🕛 Sorteio diário</div>

          <p>
            O sorteio acontece
            <strong>todos os dias à meia-noite (00:00)</strong>, horário de
            Brasília.
            <br />
            Veja resultados anteriores nas páginas
            <strong>"Meus bilhetes"</strong> ou
            <strong>"Todos os Sorteios"</strong> — com total transparência!
          </p>
        </div>

        <div class="mt-5">
          <div class="text-h5 font-weight-bold mb-2">
            🎁 Outras formas de ganhar
          </div>

          <p>
            🎯 <strong>Cotas Premiadas:</strong> ganhe R$ 100 instantaneamente
            com seus números da sorte.
          </p>

          <p>
            🥇 <strong>Ranking Apoiador:</strong> o participante que finalizar o
            dia com o maior número de bilhetes ganha R$ 200!
          </p>

          <p>
            🎉 <strong>Bônus Diário:</strong> complete o primeiro desafio e gire
            a <strong>Roleta Premiada</strong> com prêmios surpresa!
          </p>

          <p>
            💎 <strong>Raspadinhas:</strong> acesse a loja, verifique nosso
            <strong>catálogo</strong> com prêmiações instantâneas!
          </p>
        </div>

        <div class="d-flex justify-end mt-4">
          <v-btn class="btn" color="primary" @click="close()"
            >Começar agora
          </v-btn>
        </div>
      </v-stepper-content>
    </v-stepper>
  </CustomDialog>
</template>

<script>
import CustomDialog from "@/components/customDialog/CustomDialog";

export default {
  name: "Tutorial",

  components: {
    CustomDialog,
  },

  data() {
    return {
      dialog: false,
      step: 1,
    };
  },

  methods: {
    open() {
      this.dialog = true;
      this.step = 1;
    },

    close() {
      this.dialog = false;
      this.$emit("closed");
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
